import { useEffect, useState } from "react";
import { api, fmtErr } from "../../lib/api";
import { toast } from "sonner";

export default function NotificationPrefs() {
  const [events, setEvents] = useState([]);
  const [saving, setSaving] = useState("");
  const [emailConfigured, setEmailConfigured] = useState(false);

  useEffect(() => {
    api.get("/notifications/preferences").then((r) => setEvents(r.data.events)).catch(() => {});
    api.get("/org/email-status").then((r) => setEmailConfigured(!!r.data.configured)).catch(() => {});
  }, []);

  const toggle = async (ev, channel) => {
    const next = { ...ev, [channel]: !ev[channel] };
    setEvents((es) => es.map((e) => (e.key === ev.key ? next : e)));
    setSaving(ev.key + channel);
    try {
      await api.patch("/notifications/preferences",
        { preferences: { [ev.key]: { in_app: next.in_app, email: next.email } } });
    } catch (e) {
      toast.error(fmtErr(e));
      setEvents((es) => es.map((x) => (x.key === ev.key ? ev : x)));
    } finally { setSaving(""); }
  };

  const Tog = ({ ev, channel }) => {
    const on = ev[channel];
    const disabled = channel === "email" && !emailConfigured;
    return (
      <button onClick={() => !disabled && toggle(ev, channel)} disabled={disabled || saving === ev.key + channel}
        data-testid={`pref-${ev.key}-${channel}`}
        title={disabled ? "Configure email in Settings → Email" : `${on ? "On" : "Off"} — click to toggle`}
        className={`h-5 px-2 rounded-full text-[9px] font-mono uppercase tracking-wider border transition-colors disabled:opacity-40 ${
          on ? "bg-[var(--c-green)]/15 border-[var(--c-green)]/50 text-[var(--c-green)]" : "bg-[var(--c-border)]/40 border-[var(--c-border)] text-[var(--c-muted)]"}`}>
        {on ? "on" : "off"}
      </button>
    );
  };

  return (
    <div className="space-y-2" data-testid="notification-prefs">
      {!emailConfigured && (
        <div className="text-[11px] text-[var(--c-amber)] bg-[var(--c-amber)]/10 border border-[var(--c-amber)]/40 rounded-sm px-3 py-2"
          data-testid="email-not-configured-banner">
          ⚠ Email not configured. Notification emails are skipped — in-app notifications still work.
        </div>
      )}
      <div className="grid grid-cols-[1fr_64px_64px] gap-2 items-center text-[9px] font-mono uppercase tracking-widest text-[var(--c-muted)] px-1">
        <span>Event</span><span className="text-center">In-App</span><span className="text-center">Email</span>
      </div>
      <div className="max-h-96 overflow-y-auto pr-1">
        {events.map((ev) => (
          <div key={ev.key} className="grid grid-cols-[1fr_64px_64px] gap-2 items-center py-1.5 border-b border-[var(--c-border)]/40 last:border-0"
            data-testid={`pref-row-${ev.key}`}>
            <span className="text-[12px] text-[var(--c-text)]">{ev.label}</span>
            <span className="flex justify-center"><Tog ev={ev} channel="in_app" /></span>
            <span className="flex justify-center"><Tog ev={ev} channel="email" /></span>
          </div>
        ))}
      </div>
    </div>
  );
}
